module.exports = __webpack_public_path__ + "media/images/tip-box-top-grey-3bd05964.gif";